/**
 * 火车票灰度常量（与 monorepo @hs/shared/common/constants 一致）
 * Settings / CacheValue 统一字段：IsUseNewTrain（boolean）
 * 内部标识 0/1；前缀 api / trainv2api 仅在子应用请求时映射
 * 缺省：旧（FLAG_LEGACY / api）
 */

/** Settings.TrainSettings / CacheValue 统一灰度布尔字段名 */
export const TRAIN_SETTINGS_IS_USE_NEW_TRAIN = 'IsUseNewTrain'

/** @deprecated 与 TRAIN_SETTINGS_IS_USE_NEW_TRAIN 同值 */
export const TRAIN_API_PREFIX_CACHE_KEY = TRAIN_SETTINGS_IS_USE_NEW_TRAIN

export const TRAIN_API_PREFIX_LEGACY = 'api'
export const TRAIN_API_PREFIX_NEW = 'trainv2api'
export const TRAIN_API_PREFIX_DEFAULT = TRAIN_API_PREFIX_LEGACY

export const TRAIN_API_PREFIX_FLAG_NEW = 1
export const TRAIN_API_PREFIX_FLAG_LEGACY = 0

export const TRAIN_UNIT_API_PREFIX_KEY = 'TRAIN_UNIT_API_PREFIX'
